module.exports = __webpack_public_path__ + "static/img/bg4.ac66f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg4.png
// module id = Ie0Z
// module chunks = 0